<template>
    <MainSlot>
        <div class="container page_bg">
            <div class="empty_state_wrapper">
                <svg width="350" height="212" viewBox="0 0 350 212" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_4994:138391)">
                        <path
                            d="M135.431 202.607C190.193 220.706 250.544 201.106 282.801 153.509C299.855 128.346 308.515 95.9486 291.192 57.3008C260.226 -11.7862 199.628 1.97126 165.563 16.7776C149.088 23.9199 131.688 28.7272 113.868 31.06C81.8036 35.29 34.3438 52.4944 49.3888 118.6C60.2934 166.514 98.9543 190.551 135.431 202.607Z"
                            fill="white" fill-opacity="0.75"/>
                        <path
                            d="M131.5 92C143.926 92 154 81.9264 154 69.5C154 57.0736 143.926 47 131.5 47C119.074 47 109 57.0736 109 69.5C109 81.9264 119.074 92 131.5 92Z"
                            fill="#FA604A"/>
                        <path
                            d="M129.223 172.415C144.121 172.415 156.199 160.337 156.199 145.438C156.199 130.54 144.121 118.462 129.223 118.462C114.324 118.462 102.246 130.54 102.246 145.438C102.246 160.337 114.324 172.415 129.223 172.415Z"
                            fill="#B8B5C8"/>
                        <path
                            d="M131.526 132.632L129.791 132.338L129.693 132.916C129.661 133.106 128.109 142.478 127.502 156.143L115.671 149.81L114.841 151.362L127.424 158.097C127.002 169.67 127.297 184.009 129.693 198.383L129.789 198.961L131.524 198.672L131.428 198.094C128.82 182.443 128.724 166.812 129.327 154.804L141.898 148.076L141.069 146.524L129.438 152.749C130.121 141.097 131.404 133.351 131.428 133.21L131.526 132.632Z"
                            fill="#A4A0BA"/>
                        <path
                            d="M93.5961 152.182C118.778 152.182 139.192 131.768 139.192 106.586C139.192 81.4043 118.778 60.9902 93.5961 60.9902C68.4141 60.9902 48 81.4043 48 106.586C48 131.768 68.4141 152.182 93.5961 152.182Z"
                            fill="#CBD1E8"/>
                        <path
                            d="M97.2951 84.7421L95.5604 84.4482L95.4624 85.0265C95.4331 85.1996 92.7605 101.153 91.4343 124.759C91.3112 126.952 91.1974 129.258 91.098 131.666L67.303 118.939L66.4731 120.49L91.0214 133.62C90.3536 151.63 90.5285 174.949 93.509 199.245L95.2635 199.098C91.9169 171.864 92.1134 145.841 93.0654 127.199L117.615 114.059L116.785 112.508L93.1748 125.145L93.1904 124.867C94.5114 101.346 97.1728 85.4631 97.197 85.3204L97.2951 84.7421Z"
                            fill="#A4A0BA"/>
                        <path
                            d="M243.674 198.575C243.674 198.575 243.564 198.626 243.357 198.713C243.192 198.782 242.964 198.875 242.68 198.982C240.149 199.945 233.168 202.131 226.268 200.116C217.631 197.591 212.395 189.434 212.395 189.434C212.395 189.434 220.454 185.699 228.729 187.614C229.087 187.695 229.444 187.788 229.801 187.893C237.316 190.09 242.256 196.551 243.413 198.192C243.586 198.438 243.674 198.575 243.674 198.575Z"
                            fill="#DADEED"/>
                        <path opacity="0.1"
                              d="M243.412 198.192C243.393 198.395 243.373 198.57 243.357 198.713C243.318 199.027 243.29 199.197 243.29 199.197C243.29 199.197 243.07 199.128 242.68 198.983C240.543 198.192 233.318 195.129 229.321 188.644C229.111 188.304 228.914 187.961 228.729 187.615C229.086 187.696 229.443 187.789 229.801 187.894C237.316 190.091 242.256 196.551 243.412 198.192Z"
                              fill="#9235A1"/>
                        <path
                            d="M240.874 181.478C245.603 189.147 244.027 198.697 244.027 198.697C244.027 198.697 234.785 195.813 230.057 188.145C225.328 180.476 226.904 170.926 226.904 170.926C226.904 170.926 236.146 173.81 240.874 181.478Z"
                            fill="#DADEED"/>
                        <path
                            d="M246.365 113.477C215.029 113.477 189.626 88.0744 189.626 56.7386C189.626 25.4027 215.029 0 246.365 0C277.701 0 303.104 25.4027 303.104 56.7386C303.104 88.0744 277.701 113.477 246.365 113.477Z"
                            fill="#DADEED"/>
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M242.181 24.1885L242.083 23.6102L243.817 23.3164L243.915 23.8946C243.955 24.126 247.61 45.9431 249.423 78.2293C249.601 81.385 249.764 84.712 249.904 88.1929L282.731 70.6344L283.561 72.1858L249.981 90.1474C251.073 119.354 250.55 158.822 243.916 198.625L243.819 199.203L242.084 198.914L242.18 198.336C249.487 154.499 249.354 111.044 247.829 81.3509L214.264 63.3859L215.095 61.8347L247.72 79.2971C247.703 78.9754 247.685 78.6553 247.667 78.3371C245.859 46.1361 242.215 24.3895 242.181 24.1885Z"
                              fill="#A4A0BA"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_4994:138391">
                            <rect width="350" height="212" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>

                <div class="message">{{$t("PageNotFound['There’s nothing here...']")}}</div>
                <div class="empty_state_text">{{$t("PageNotFound['...maybe the page you're looking for is not found or never existed.']")}}</div>
                <div class="buttons_wrapper"
                     :class="{
                    wrapper_center:isLogged && isLoginChecked,
                    wrapper_between:!isLogged || !isLoginChecked
                }"
                >
                    <router-link v-if="!isLogged || !isLoginChecked" to="/login" class="btn">{{$t("PageNotFound['Log in']")}}</router-link>
                    <a :href="homeUrl" class="btn">{{$t("PageNotFound['Back to home']")}}</a>
                </div>
            </div>
        </div>
    </MainSlot>
</template>

<script>
import MainSlot from "../components/MainSlot";
import {mapGetters, mapMutations} from "vuex";

export default {
    mounted() {
        this.checkLoginState();
    },
    methods: {
        ...mapMutations([
            'setLoading',
            'setLogged',
            'setLoginChecked'
        ]),
        async checkLoginState() {
            if (!this.isLogged || !this.isLoginChecked) {
                try {
                    await this.$http.refreshToken();
                    this.setLogged(true);
                    this.setLoginChecked(true);
                } catch (e) {
                    if (e.response && e.response.status === 403) {
                        this.setLogged(false);
                        this.setLoginChecked(true);
                    }
                }
            }
            this.setLoading(false);
        }
    },
    computed: {
        ...mapGetters([
            'isLogged',
            'isLoginChecked',
        ]),
        homeUrl() {
            if (this.isLogged && this.isLoginChecked) {
                return this.$router.resolve('/events').href;
            }
            return window.location.origin || '/';
        },
    },
    components: {MainSlot},
    name: "PageNotFound"
}
</script>

<style lang="scss" scoped>

.buttons_wrapper {
    position: relative;
    padding-top: 30px;

    &.wrapper_between {
        width: auto;
    }

    .btn {
        margin: 0 15px;
    }

    @media screen and (max-width: 600px) {
        &.wrapper_between {
            width: 100%;
        }
        .btn {
            margin: 0;
            max-width: calc(50% - 15px);
            padding: 16px 0;
            min-width: calc(50% - 15px);
        }
    }
}

.page_bg {
    display: flex;
    align-items: center;
    justify-content: center;
}

.empty_state_wrapper {
    padding: 0 15px;
    text-align: center;

    .message {
        font-style: normal;
        font-weight: bold;
        font-size: 18px;
        line-height: 23px;
        color: #272727;
        margin: 15px 0;
    }
}
</style>
